__turbopack_context__.v({
  "coverDetailsDrawerContentTitle": "Rs0t4q_coverDetailsDrawerContentTitle",
});
